import React from "react";
import { formatConvocationDate } from "../utils/dateFormat";

const DetailsNew = ({ singleUser }) => {
    return (
        <div className="dash-main-left">
            <div className="dash-left-div">
                <h2 className="dash-details-head">Student Details</h2>

                <div className="table-responsive dash-table-div">
                    <table className="table table-striped table-borderless">
                        <tbody>
                            <tr className="table-dark">
                                <th>Field</th>
                                <th>Details</th>
                            </tr>
                            <tr><th>Faculty</th><td>{singleUser.faculty}</td></tr>
                            <tr><th>School</th><td>{singleUser.school}</td></tr>
                            <tr><th>Program</th><td>{singleUser.programme}</td></tr>
                            <tr><th>Registration No</th><td>{singleUser.reg_no}</td></tr>
                            <tr><th>Student Name</th><td>{singleUser.student_name}</td></tr>
                            <tr><th>Gender</th><td>{singleUser.gender}</td></tr>
                            <tr><th>Admitted Batch</th><td>{singleUser.batch}</td></tr>
                            <tr><th>Credits</th><td>{singleUser.credits}</td></tr>
                            <tr><th>GPA</th><td>{singleUser.cgpa === "0" || singleUser.cgpa === 0 ? "NA" : singleUser.cgpa}</td></tr>
                            <tr><th>Email</th><td>{singleUser.email}</td></tr>
                            <tr><th>Day</th><td>{formatConvocationDate(singleUser.day)}</td></tr>
                            <tr><th>companions</th><td>{singleUser.companions}</td></tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default DetailsNew;